<script>
export default {
  data: function() {
    return {
      visible: false,
      title: '表单对话框',
      width: '30%',
      formSubmit: null,
      formClose: null,
      formTpl: null,
      isLoading: false,
      readonly: false
    }
  },
  methods: {
    onOK: function() {
      const formComponent = this.formTpl.componentInstance
      formComponent.submit(formData => {
        this.isLoading = true
        var res = this.formSubmit(formData)
        if (res && res.then) {
          res.then(() => {
            this.visible = false
            this.formTpl = null
            this.visible = false
          }).finally(() => {
            this.isLoading = false
          })
        } else {
          this.visible = false
          this.formTpl = null
          this.visible = false
          this.isLoading = false
        }
      })
    },
    init: function({ title, formTpl, formSubmit, formClose, width, readonly }) {
      this.title = title
      this.formSubmit = formSubmit
      this.formClose = formClose
      this.formTpl = formTpl

      if (width) this.width = width
      this.readonly = readonly

      return this
    },
    show: function() {
      this.visible = true
    },
    close: function() {
      if (this.formClose) {
        this.formClose()
      }
      if (this.visible) {
        this.formTpl = null
        this.visible = false
      }
    }
  },
  render: function(h) {
    return h('el-dialog', {
      props: {
        title: this.title,
        visible: this.visible,
        width: this.width,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
        destroyOnClose: true
      },
      on: {
        'update:visible': val => this.visible = val
      }
    }, [
      this.formTpl ? this.formTpl : '',
      <span class='dialog-footer' slot='footer'>
        <el-button onClick={this.close}>关闭</el-button>
        { this.readonly ? '' : <el-button type='primary' loading={this.isLoading} onClick={this.onOK}>提交{ this.isLoading ? '中...' : '' }</el-button> }
      </span>
    ])
  }
}
</script>
